import { render, staticRenderFns } from "./Overlays_Edit.vue?vue&type=template&id=77012a02&"
import script from "./Overlays_Edit.vue?vue&type=script&lang=js&"
export * from "./Overlays_Edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports